import Vue from 'vue';

const eventBus = {};

eventBus.install = (vm) => {
  vm.prototype.$bus = new Vue();
};

Vue.use(eventBus);
